import {
  baseRequestWithAxiosResponse,
  baseRequestWithHeaders,
} from './base-request';

export const fetchAllCenterDataUpdateRequests = () => {
  const url = `network-center/get-center-update-requests`;
  const method = 'GET';
  return baseRequestWithHeaders(url, method, null);
};

export const updateRequestStatus = (body) => {
  const url = `network-center/update-center-update-requests`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
};

export function updateZohoId(body) {
  const url = `network-center/update-zoho-id`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
}

export function updateBankDetails(body) {
  const url = `network-center/update-bank-details`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
}

// export const approveRequestStatus = (body) => {
//   const url = `practice/doctor-practice`;
//   const method = 'POST';
//   return baseRequestWithHeaders(url, method, null, body);
// };
